module.exports = sensorsDataAnalytic201505;